import { IBaseCriteria } from './base-criteria';

/**
 * Interface base que representa el criterio de busqueda de receivers
 */
export interface IReceiverCriteria extends IBaseCriteria {
}

export let emptyReceiverCriteria: IReceiverCriteria = {
  filter: '',
  value: '',
  page: 1
};



// WEBPACK FOOTER //
// ./src/app/model/receiver-criteria.ts